























import { AppModule } from '@app/componentlib/src/store/modules/app'
import Vue from "vue"
import Component from "vue-class-component"

@Component<ImageCard>({
  props: {
    item: Object,
    selectDesign: String
  }
})
export default class ImageCard extends Vue {
  /**
   * Props variables
   */
  item: Object | undefined
  /**
   * Component state variables
   */
  /**
   * Lifecycle
   */
  /**
   * Getters
   */
   get t (): any {
    return AppModule.translations
  }
  /**
   * Methods
   */
   selectItem (item: object) {
     this.$emit('selectItem', item)
   }
}
